
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "overview"
    }}>{`Overview`}</h1>
    <p>{`Atlas is a scalable and extensible set of core foundational governance services – enabling
enterprises to effectively and efficiently meet their compliance requirements within Hadoop and
allows integration with the whole enterprise data ecosystem.`}</p>
    <p>{`Apache Atlas provides open metadata management and governance capabilities for organizations
to build a catalog of their data assets, classify and govern these assets and provide collaboration
capabilities around these data assets for data scientists, analysts and the data governance team.`}</p>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <h3 {...{
      "id": "metadata-types--instances"
    }}>{`Metadata types & instances`}</h3>
    <ul>
      <li parentName="ul">{`Pre-defined types for various Hadoop and non-Hadoop metadata`}</li>
      <li parentName="ul">{`Ability to define new types for the metadata to be managed`}</li>
      <li parentName="ul">{`Types can have primitive attributes, complex attributes, object references; can inherit from other types`}</li>
      <li parentName="ul">{`Instances of types, called entities, capture metadata object details and their relationships`}</li>
      <li parentName="ul">{`REST APIs to work with types and instances allow easier integration`}</li>
    </ul>
    <h3 {...{
      "id": "classification"
    }}>{`Classification`}</h3>
    <ul>
      <li parentName="ul">{`Ability to dynamically create classifications - like PII, EXPIRES_ON, DATA_QUALITY, SENSITIVE`}</li>
      <li parentName="ul">{`Classifications can include attributes - like expiry_date attribute in EXPIRES_ON classification`}</li>
      <li parentName="ul">{`Entities can be associated with multiple classifications, enabling easier discovery and security enforcement`}</li>
      <li parentName="ul">{`Propagation of classifications via lineage - automatically ensures that classifications follow the data as it goes through various processing`}</li>
    </ul>
    <h3 {...{
      "id": "lineage"
    }}>{`Lineage`}</h3>
    <ul>
      <li parentName="ul">{`Intuitive UI to view lineage of data as it moves through various processes`}</li>
      <li parentName="ul">{`REST APIs to access and update lineage`}</li>
    </ul>
    <h3 {...{
      "id": "searchdiscovery"
    }}>{`Search/Discovery`}</h3>
    <ul>
      <li parentName="ul">{`Intuitive UI to search entities by type, classification, attribute value or free-text`}</li>
      <li parentName="ul">{`Rich REST APIs to search by complex criteria`}</li>
      <li parentName="ul">{`SQL like query language to search entities - Domain Specific Language (DSL)`}</li>
    </ul>
    <h3 {...{
      "id": "security--data-masking"
    }}>{`Security & Data Masking`}</h3>
    <ul>
      <li parentName="ul">{`Fine-grained security for metadata access, enabling controls on access to entity instances and operations like add/update/remove classifications`}</li>
      <li parentName="ul">{`Integration with Apache Ranger enables authorization/data-masking on data access based on classifications associated with entities in Apache Atlas. For example:`}
        <ul parentName="li">
          <li parentName="ul">{`who can access data classified as PII, SENSITIVE`}</li>
          <li parentName="ul">{`customer-service users can only see last 4 digits of columns classified as NATIONAL_ID`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#/WhatsNew-2.4"
        }}>{`What's new in Apache Atlas 2.4?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#/Installation"
        }}>{`Build & Install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#/QuickStart"
        }}>{`Quick Start`}</a></li>
    </ul>
    <h2 {...{
      "id": "api-documentation"
    }}>{`API Documentation`}</h2>
    <ul>
      <li parentName="ul">
        <a href="api/v2/index.html">REST API Documentation</a>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#/ImportExportAPI"
        }}>{`Export & Import REST API Documentation`}</a></li>
      <li parentName="ul">
        <a href="../api/rest.html">Legacy API Documentation</a>
      </li>
    </ul>
    <h2 {...{
      "id": "developer-setup-documentation"
    }}>{`Developer Setup Documentation`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#/EclipseSetup"
        }}>{`Developer Setup: Eclipse`}</a></li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;